import { render, staticRenderFns } from "./Upgradeexplain.vue?vue&type=template&id=5efc6bbf&scoped=true"
import script from "./Upgradeexplain.vue?vue&type=script&lang=js"
export * from "./Upgradeexplain.vue?vue&type=script&lang=js"
import style0 from "./Upgradeexplain.vue?vue&type=style&index=0&id=5efc6bbf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5efc6bbf",
  null
  
)

export default component.exports